export default {
  title: 'Components/DDA Header Menu/ DDA Header Menu',
  component: 'dda-header-menu',
  argTypes: {
    quickLinks: {
      control: 'object',
      description: 'Array of quick links with optional submenu type and children',
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
Each menu item can define its own submenu type:

- \`type: 'dda_default_submenu'\` — basic list
- \`type: 'dda_main_megamenu'\` — 4-column mega menu

\`\`\`ts
{
  headerMenuLabel: 'About Us',
  url: '#',
  type: 'dda_default_submenu',
  children: [ { headerMenuLabel: 'Submenu 1', url: '#' }, ... ]
}
\`\`\`

\`\`\`ts
{
  headerMenuLabel: 'Services',
  url: '#',
  type: 'dda_main_megamenu',
  children: [
    { title: 'Column 1', items: [{ headerMenuLabel: 'Submenu 1', url: '#' }] },
    ...
  ]
}
\`\`\`
        `,
      },
    },
  },
};

const Template = args => `
  <dda-header-menu
    quick-links='${JSON.stringify(args.quickLinks)}'
  ></dda-header-menu>
`;

export const Default = Template.bind({});
Default.args = {
  quickLinks: [
    { headerMenuLabel: 'Home', active: 'true', url: '#' },

    // default dropdown menu
    {
      headerMenuLabel: 'About Us',
      url: 'javascript:void(0)',
      type: 'dda_default_submenu',
      children: [
        {
          headerMenuLabel: 'Submenu 1',
          url: '#',
          headerMenuId: 'customeID',
          defaultSubMenuTitle: 'Submenu 1 Title',
          children: [
            { headerMenuLabel: 'SubSubmenu 1', url: '#' },
            { headerMenuLabel: 'SubSubmenu 1', url: '#' },
          ],
        },
        {
          headerMenuLabel: 'Submenu 2',
          url: '#',
          headerMenuId: 'customeID',
          defaultSubMenuTitle: 'Submenu 2 Title',
          children: [
            { headerMenuLabel: 'SubSubmenu 2', url: '#' },
            { headerMenuLabel: 'SubSubmenu 2', url: '#' },
          ],
        },
        {
          headerMenuLabel: 'Submenu 3',
          url: '#',
          headerMenuId: 'customeID',
        },
      ],
    },

    // mega menu
    {
      headerMenuLabel: 'Services',
      url: 'javascript:void(0)',
      type: 'dda_main_megamenu',
      children: [
        {
          title: 'QUICK LINKS 1',
          items: [
            {
              headerMenuLabel: 'Service 1',
              url: '#',
              description: 'Service Description',
            },
            { headerMenuLabel: 'Service 2', url: '#' },
            { headerMenuLabel: 'Service 3', url: '#' },
          ],
        },
        {
          title: 'QUICK LINKS 2',
          items: [
            { headerMenuLabel: 'Service 1', url: '#' },
            { headerMenuLabel: 'Service 2', url: '#' },
            { headerMenuLabel: 'Service 3', url: '#' },
          ],
        },
        {
          title: 'QUICK LINKS 3',
          items: [{ headerMenuLabel: 'Service 3', url: '#' }],
        },
        {
          title: 'QUICK LINKS 4',
          items: [{ headerMenuLabel: 'Service 4', url: '#' }],
        },
      ],
    },

    { headerMenuLabel: 'Contact', url: '#' },
  ],
};
